function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnbLogoNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#161619",
    d: "M 16.5,-0.5 C 21.1667,-0.5 25.8333,-0.5 30.5,-0.5C 38.5,2.83333 44.1667,8.5 47.5,16.5C 47.5,21.1667 47.5,25.8333 47.5,30.5C 44.1667,38.5 38.5,44.1667 30.5,47.5C 25.8333,47.5 21.1667,47.5 16.5,47.5C 8.5,44.1667 2.83333,38.5 -0.5,30.5C -0.5,25.8333 -0.5,21.1667 -0.5,16.5C 2.83333,8.5 8.5,2.83333 16.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d3a30e",
    d: "M 22.5,9.5 C 25.7143,10.4404 28.7143,11.9404 31.5,14C 28.6526,15.8517 26.1526,15.3517 24,12.5C 22.1435,14.4062 19.9769,15.2395 17.5,15C 17.1667,14.6667 16.8333,14.3333 16.5,14C 18.7472,12.7225 20.7472,11.2225 22.5,9.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcaa0d",
    d: "M 12.5,15.5 C 13.9778,15.238 15.3112,15.5713 16.5,16.5C 15.1369,17.8928 14.3036,19.5595 14,21.5C 11.4077,19.9917 10.9077,17.9917 12.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c29710",
    d: "M 21.5,15.5 C 23.288,15.2148 24.9547,15.5481 26.5,16.5C 24.3338,19.0232 22.6671,18.6898 21.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcaa0d",
    d: "M 31.5,15.5 C 36.8775,15.6892 37.7108,17.6892 34,21.5C 33.4153,19.3386 32.5819,17.3386 31.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4b00c",
    d: "M 18.5,17.5 C 20.4021,18.3679 22.2355,19.3679 24,20.5C 25.6565,19.5159 27.3232,18.5159 29,17.5C 32.4244,20.9772 31.7577,23.6439 27,25.5C 26.7638,27.764 26.2638,29.9307 25.5,32C 24.2161,32.6838 23.0495,32.5171 22,31.5C 22.4403,27.5872 20.9403,24.9206 17.5,23.5C 16.2291,21.1937 16.5624,19.1937 18.5,17.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d6a50e",
    d: "M 11.5,22.5 C 12.4959,22.4142 13.3292,22.7476 14,23.5C 13.5597,27.4128 15.0597,30.0794 18.5,31.5C 19.6139,32.723 19.7805,34.0563 19,35.5C 16.7497,34.2921 14.583,32.9587 12.5,31.5C 11.5159,28.5719 11.1826,25.5719 11.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7a60e",
    d: "M 34.5,22.5 C 35.7647,23.5145 36.4313,25.0145 36.5,27C 35.86,31.316 33.36,34.1494 29,35.5C 28.2195,34.0563 28.3861,32.723 29.5,31.5C 30.7481,30.9598 31.9148,30.2931 33,29.5C 33.2904,27.0796 33.7904,24.7463 34.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b68d10",
    d: "M 16.5,25.5 C 19.2748,25.8338 19.9415,27.1671 18.5,29.5C 16.8888,28.6798 16.2222,27.3464 16.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b48c0f",
    d: "M 29.5,25.5 C 32.0414,26.6228 32.0414,27.9561 29.5,29.5C 28.3744,28.1916 28.3744,26.8583 29.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d4a40f",
    d: "M 21.5,33.5 C 23.0098,34.7279 24.5098,34.7279 26,33.5C 26.7805,34.9437 26.6139,36.277 25.5,37.5C 22.5213,38.3563 21.188,37.0229 21.5,33.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbLogoNetwork);
export default __webpack_public_path__ + "static/media/bnb_logo_network.4c3e3aa5d4c36e2812facf5757c691c4.svg";
export { ForwardRef as ReactComponent };